import React, { useEffect, useState, useContext, Suspense } from 'react';
import { ReactReduxContext } from 'react-redux';
import SocialLogin from '../user/SocialLogin';
import LoginForm from '../user/LoginForm';
import SignupForm from '../user/SignupForm';
import ForgetForm from '../user/ForgetForm';
import '../../assets/scss/app/cover-letter-screens/cover-login.scss';
import { EDITOR_LINK, DASHBOARD_LINK, COVERLETTER_FINALIZE, COVERLETTER_WORKSTYLE } from '../../constants/constants';
import Splash from '../common/Splash';
import { removeBodyScroll } from '../../helper';
import WpAPI from '../../WpApi';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { useCoverLetter } from '../../context/CoverLetterContext';
import Loader from '../common/Loader';
import PageLoader from '../common/PageLoader';
let TPL = {}
TPL['template-eleven'] = React.lazy(() => import('./templates/static/TemplateEleven'));
TPL['template-twelve'] = React.lazy(() => import('./templates/static/TemplateTwelve'));
TPL['template-thirteen'] = React.lazy(() => import('./templates/static/TemplateThirteen'));
TPL['template-fourteen'] = React.lazy(() => import('./templates/static/TemplateFourteen'));
//TPL['template-fifteen'] = React.lazy(() => import('./templates/static/TemplateFifteen'));
TPL['template-sixteen'] = React.lazy(() => import('./templates/static/TemplateSixteen'));
TPL['template-sixteen-v2'] = React.lazy(() => import('./templates/static/TemplateSixteenV2'));
TPL['template-seventeen'] = React.lazy(() => import('./templates/static/TemplateSeventeen'));
TPL['template-eighteen'] = React.lazy(() => import('./templates/static/TemplateEighteen'));
TPL['template-nineteen'] = React.lazy(() => import('./templates/static/TemplateNineteen'));
TPL['template-twenty'] = React.lazy(() => import('./templates/static/TemplateTwenty'));
TPL['template-twenty-one'] = React.lazy(() => import('./templates/static/TemplateTwentyOne'));
TPL['template-twenty-three'] = React.lazy(() => import('./templates/static/TemplateTwentyThree'));
TPL['template-twenty-three-v2'] = React.lazy(() => import('./templates/static/TemplateTwentyThreeV2'));
TPL['template-twenty-four'] = React.lazy(() => import('./templates/static/TemplateTwentyFour'));
const Login = (props) => {

    const [toggleForm, setToggleForm] = useState('signup');
    const [isLoading, setIsLoading] = useState(false);
    const [back, setBack] = useState(false)
    //Separate state required to manage button click action, other than login_action_initiated
    const [loginAction, setLoginAction] = useState(false);
    const [SelectedTpl, setSelectedTpl] = useState();
    const {
        login_action_initiated,
        login_action_successful,
        active_template,
        active_color,
        qa_steps_initiated,
        custom_template_color,
        handlers: {
            update2Preview,
            createCoverLetter,
            loadQA
        },
    } = useCoverLetter();

    useEffect(() => {
        setSelectedTpl(TPL[active_template ?? 'template-eleven']);
    }, [active_template]);
    useEffect(() => {
        //remove scroll position when page loads
        window.scrollTo(0, 0)
        removeBodyScroll(false);
        loadQA()
    }, [])
    useEffect(() => {
        // to handle if this is used to show popup and unhandled cases arises because of back button usages
        localStorage.removeItem('clickAction')
    }, []);
    const loginSuccessfullyCompleted = () => {
        WpAPI.loadCoverLettersInDashboard((res) => {
            createCoverLetter()
            setLoginAction(false)
            update2Preview({ login_action_initiated: false, login_action_successful: true })
        })
    }
    const loginInitiationInterrupted = () => {
        setLoginAction(false)
        update2Preview({ login_action_initiated: false });
        setIsLoading(false)
        window.innerWidth < 880 && window.scrollTo(0, 0)
    }
    const loginInitiated = () => {
        setLoginAction(true)
        update2Preview({ login_action_initiated: false, login_action_successful: false })
    }

    if (login_action_successful && !login_action_initiated) return <Redirect to={COVERLETTER_FINALIZE} />
    if (back) return <Redirect to={COVERLETTER_WORKSTYLE} />
    return (<>
        {/* <Splash cssClass={'mt width-982'} /> */}
        <div className="cover-page-outer">
            <div className="cover-login-signup-header">
                <h1>Let's save your cover letter!</h1>
                <p>Create an account to save and edit your cover letter.</p>
            </div>
            <div className="login-page">
                <div className="login-block">
                    <div className="login">
                            <h3>Welcome to <span>AI Resume Builder</span></h3>

                        {toggleForm != 'forgetpassword' && <><SocialLogin
                            label={toggleForm == 'login' ? 'Login' : 'Sign up'}
                            redirect={DASHBOARD_LINK}
                            setIsLoading={setIsLoading}
                            type={'coverletter_page'}
                            loginInitiationInterrupted={loginInitiationInterrupted}
                            loginInitiated={loginInitiated}
                            loginSuccessfullyCompleted={loginSuccessfullyCompleted}
                        />
                            <div className="or-text"><span>OR</span></div></>
                        }
                        {toggleForm == 'login' && <><LoginForm
                            redirect={EDITOR_LINK}
                            type={'coverletter_page'}
                            setIsLoading={setIsLoading}
                            loginInitiationInterrupted={loginInitiationInterrupted}
                            loginInitiated={loginInitiated}
                            loginSuccessfullyCompleted={loginSuccessfullyCompleted}
                        /><div className="forget-links" onClick={() => setToggleForm('forgetpassword')}><span>Forgot Password?</span></div></>}
                        {toggleForm == 'signup' && <SignupForm
                            redirect={EDITOR_LINK}
                            type={'coverletter_page'}
                            setIsLoading={setIsLoading}
                            loginInitiated={loginInitiated}
                            loginInitiationInterrupted={loginInitiationInterrupted}
                            loginSuccessfullyCompleted={loginSuccessfullyCompleted}
                        />}
                        {toggleForm == 'forgetpassword' && <ForgetForm pagetype={'coverletter'} />}

                        <div className="login-signup-toggle">
                            {toggleForm == 'signup' && <span className="account-text" onClick={() => setToggleForm('login')}>Already have an account? Sign In</span>}
                            {toggleForm == 'login' && <span className="account-text" onClick={() => setToggleForm('signup')}>Don't have account? Sign Up</span>}
                            {toggleForm == 'forgetpassword' && <span className="account-text" onClick={() => setToggleForm('login')}>Back</span>}
                            {/* <div className="toggle-base">
                                <span
                                    className={`signup-link  ${toggleForm == 'signup' ? 'active' : ''}`}
                                    onClick={() => {
                                        setToggleForm('signup');
                                    }}>
                                    Sign Up
                                </span>
                                <span
                                    className={`login-link ${toggleForm == 'login' ? 'active' : ''}`}
                                    onClick={() => {
                                        setToggleForm('login');
                                    }}>
                                    Login
                                </span>
                            </div> */}
                        </div>
                        {isLoading && <div className="fade-screen">
                            <Loader
                                className="set-loader"
                                text={toggleForm == 'login' ? `Logging in...` : `Registering...`}
                            />
                        </div>
                        }
                    </div>
                </div>
                <div className="cover-letter-preview">
                   <div className="cover-preview-new"> {SelectedTpl && <Suspense fallback={<PageLoader />}>
                        <div className="static-" ><SelectedTpl color={active_color ? active_color : 'color-variant-one'} customColor={custom_template_color} />
                        </div>
                    </Suspense>}</div>
                    {/* <figure className="cover-preview"><img src="/assets/images/login-temp.png" alt="cover preview" /> </figure> */}
                </div>
            </div>
            {toggleForm !== 'forgetpassword' && <div className="cover-letter-action">
                <button className="round-btn" onClick={() => setBack(true)}><i className="arrow-bar-left"></i><span>Back</span></button>
                <button className="round-btn active btn-process" onClick={() => {
                    loginAction || login_action_initiated || update2Preview({ login_action_initiated: true, login_action_successful: false })
                }} ><span id="_submit_button" >{!(login_action_initiated || loginAction) ? 'Generate Cover Letter' : 'Processing'}</span><i className="arrow-bar-right"></i></button>
            </div>}

        </div>
    </>);
}
export default Login